export interface IAuthState {}

export const AuthState: IAuthState = {};
